module.exports = __webpack_public_path__ + "img/company_icon.8c72ef19.png";